(function($, window, document, undefined) {
    var defaults = {
        delay: 300,
        activeClass: 'opened'
    };

    function Menu(element, options) {
        this.element = element;

        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this.init();
    }

    Menu.prototype = {
        isOpen: false,
        timeout: null,
        init: function() {
            var that = this;

            $(this).each(function(index, menu) {
                that.node = menu.element;
                that.addListeners(menu.element);
            });
        },
        addListeners: function(menu) {
            var that = this;
            $(menu)
                .mouseover(function(e) {
                    that.handleMouseOver.call(that, e);
                })
                .mouseout(function(e) {
                    that.handleMouseOut.call(that, e);
                });
        },
        handleMouseOver: function(e) {
            var that = this;
            // clear the timeout
            this.clearTimeout();

            // find the parent list item
            //var item = ('target' in e ? e.target : e.srcElement);
            var item = e.target || e.srcElement;
            while (item.nodeName != 'LI' && item != this.node) {
                item = item.parentNode;
            }

            // if the target is within a list item, set the timeout
            if (item.nodeName == 'LI') {
                this.toOpen = item;
                this.timeout = setTimeout(function() {
                    that.open.call(that);
                }, this.options.delay);
            }
        },
        handleMouseOut: function() {
            var that = this;
            // clear the timeout
            this.clearTimeout();

            this.timeout = setTimeout(function() {
                that.close.call(that);
            }, this.options.delay);
        },
        clearTimeout: function() {
            // clear the timeout
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        },
        open: function() {
            var that = this;

            // store that the menu is open
            this.isOpen = true;

            // loop over the list items with the same parent
            var items = $(this.toOpen)
                .parent()
                .children('li');

            $(items).each(function(index, item) {
                var $item = $(item);

                if ($item.has('ul').length) {
                    if (item != that.toOpen) {
                        // close the submenu
                        $item.removeClass(that.options.activeClass);
                        that.close(item);
                    } else if (!$item.hasClass(that.options.activeClass)) {
                        $item.addClass(that.options.activeClass);
                    }
                }
            });
        },

        close: function(node) {
            var that = this;
            // if no node was specified, close all menus
            if (!node) {
                this.isOpen = false;
                node = this.node;
            }

            // loop over the items, closing their submenus
            $(node)
                .children('li')
                .removeClass(this.options.activeClass);
        }
    };

    $('.js-menu').each(function() {
        new Menu(this);
    });

    $('.js-mobile-menu').each(function() {
        var $this = $(this),
            submenu = $this.find('.js-submenu');

        submenu.each(function() {
            var current = $(this),
                trigger = current.siblings('a'),
                parent = current.parent();

            trigger.on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                parent.toggleClass('show');

                if (parent.is('.show')) {
                    current.slideDown(150);
                } else {
                    current.slideUp(150);
                }
            });
        });
    });

    $('.js-hamburger').on('click', function(e) {
        e.preventDefault();
        if ($.magnificPopup.instance.isOpen) {
            $.magnificPopup.close();
        }
    });
})(jQuery, window, document);
